export default {
  SET_UNDERLYING_FUNDS(state, payload) {
    state.Data = payload.Data;
    state.Frequency = payload.Frequency;
    state.base64ChartImage = payload.base64ChartImage;
    state.AsOfDate = payload.AsOfDate;
  }
};
